import { styled, css } from '@vebox/etui-system';
import { createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["theme", "isActive", "isLast", "isCompleted"];
const getBgColor = (isActive, isLast, isCompleted, theme) => {
  if (isCompleted) return theme.palette.text.primary;
  if (isActive) return theme.palette.text.secondary;
  if (isLast) return theme.palette.black['20'];
  return theme.palette.black['20'];
};
const getColor = (isActive, isCompleted, theme) => {
  if (isActive && !isCompleted || isCompleted) {
    return theme.palette.common.white;
  }
  return theme.palette.text.primary;
};
var StepContainer = styled(Div).attrs(_ref => {
  let {
      theme,
      isActive,
      isLast,
      isCompleted
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 auto',
    position: 'relative',
    bg: getBgColor(isActive, isLast, isCompleted, theme),
    color: getColor(isActive, isCompleted, theme),
    p: `${theme.spacing.xxs}px ${theme.spacing.lg}px`,
    fontWeight: isActive ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSizeLarge,
    minHeight: '30px'
  }, rest);
})`

&:after {
  ${({
  isActive,
  isLast,
  theme
}) => {
  if (isActive && !isLast) {
    return css`
        content: '';
        position: absolute;
        left: 100%;
        top: 0;
        border-left: ${theme.spacing.xs}px solid ${theme.palette.text.secondary};
        border-right: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-top: 15px solid transparent;
        z-index: 5;
      `;
  }
  return '';
}}
`;

const _excluded$1 = ["theme"];
var StepNumber = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    mr: `${theme.spacing.xs}px`
  }, rest);
})``;

const Step = ({
  showNumbers,
  title,
  stepNumber,
  isActive,
  isLast,
  isCompleted,
  onRender,
  styles = {}
}) => /*#__PURE__*/createElement(Fragment, null, onRender && onRender(stepNumber, isActive, isLast, isCompleted), !onRender && /*#__PURE__*/createElement(StepContainer, _extends({
  isActive: isActive,
  isCompleted: isCompleted,
  isLast: isLast
}, styles.root), showNumbers && /*#__PURE__*/createElement(StepNumber, styles.number, stepNumber), title && /*#__PURE__*/createElement(Div, styles.title, title)));

export default Step;
